export { type XstyledProps, useGetXstyledProps } from './useGetXstyledProps.js';
export { xstyledPropTypes } from './xstyledPropTypes.js';
